import React, { useEffect, useState } from "react";
import { Brain } from "lucide-react";

// Passi mostrati mentre l'AI lavora: fanno vedere che "sta ragionando" (uno ogni ~1,4 s, poi l'ultimo resta)
const PASSI = {
  traduci: ["Leggo il testo…", "Riconosco la lingua…", "Traduco frase per frase…", "Rifinisco il tono…"],
  scrivi: ["Leggo il contesto…", "Capisco cosa serve dire…", "Scrivo la risposta…", "Rifinisco il tono…"],
  elabora: ["Leggo il messaggio…", "Individuo i punti chiave…", "Riformulo il testo…", "Controllo il risultato…"],
  rispondi: ["Leggo il messaggio ricevuto…", "Capisco la richiesta…", "Preparo le risposte…", "Scelgo le parole giuste…"],
  errore: ["Leggo l'errore…", "Cerco la causa…", "Preparo la soluzione…"],
};

export const AiRagiona = ({ tipo = "elabora", titolo = "L'AI sta ragionando", compatto = false, style }) => {
  const passi = PASSI[tipo] || PASSI.elabora;
  const [i, setI] = useState(0);
  useEffect(() => {
    setI(0);
    const t = setInterval(() => setI((n) => Math.min(n + 1, passi.length - 1)), 1400);
    return () => clearInterval(t);
  }, [tipo, passi.length]);
  return (
    <div className={`ai-ragiona ${compatto ? "compatto" : ""}`} style={style} data-testid="ai-ragiona" role="status" aria-live="polite">
      <span className="ai-ragiona-icona">
        <Brain size={compatto ? 16 : 20} strokeWidth={2.4} />
      </span>
      <span className="ai-ragiona-testo">
        <span className="ai-ragiona-titolo">
          {titolo}
          <span className="ai-ragiona-punti"><i /><i /><i /></span>
        </span>
        <span className="ai-ragiona-passo" key={i} data-testid="ai-ragiona-passo">{passi[i]}</span>
      </span>
      <span className="ai-ragiona-onde"><i /><i /><i /><i /><i /></span>
    </div>
  );
};
